import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Loader } from "../../UI/Loaders/Loaders";
import Paginator from "../Pagination/Pagination.component";
import { showModal, hideModal } from "../../redux/actions/modal";
import {
  postDataWithDotNet,
  putDataWithDotNet,
} from "../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../api/ajax-endpoints";
import { errorHandler } from "../../helpers/errorHandler";
import Alert from "../../NewComponents/Alert/Alert.component";
import useDefaultWalletProvider from "../../custom-hooks/useDefaultWalletProvider";
import { useQueryCache } from "react-query";
import { appInsights } from "../../config/appInsights";

const DefaultWalletProvider = ({ loggedInUser, showModal, hideModal }) => {
  const [preState, setPreState] = useState({
    pageNumber: 1,
    size: 20,
    searchBy: 3,
  });
  const [state, setState] = useState({
    pageNumber: 1,
    size: 20,
    searchBy: 3,
    startDate: "",
    endDate: "",
    searchValue: "",
    aggregatorId: "",
  });

  const [count, setCount] = useState(null);
  const [signUpError, setSignUpError] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const { data, status, error } = useDefaultWalletProvider();
  const queryCache = useQueryCache();
  if (data) {
    if (count === null) {
      setCount(data.totalCount);
    }
  }

  const modalHandler = (modalData, type) => {
    showModal({
      modalIdentifier: "wallet",
      dataRecord: modalData,
      action: "defautwalletprovider",
      type,
      onSubmitEditDFG,
      onSubmitCreateDFG,
    });
  };

  const onSubmitCreateDFG = async ({
    provider_type,
    currency,
    consumer_type,
    bank_code,
  }) => {
    setSignUpError(false);
    setLoading(true);
    let reqBody = {
      provider_type: Number(provider_type),
      currency,
      consumer_type: Number(consumer_type),
      bank_code,
    };

    try {
      const response = await postDataWithDotNet(
        ajaxEndpoints.DEFAULT_WALLET_PROVIDER,
        reqBody
      );

      setLoading(false);
      queryCache.invalidateQueries("getDefaultWalletProvider");
      hideModal();
      setSuccessMessage(response.message);
    } catch (error) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "DefaultWalletProvider.jsx",
        },
      });
      queryCache.invalidateQueries("getDefaultWalletProvider");
      hideModal();
      setLoading(false);
      setSignUpError(errorHandler(error));
    }
  };

  const onSubmitEditDFG = async ({
    provider_type,
    currency,
    consumer_type,
    bank_code,
    id,
  }) => {
    setSignUpError(false);
    setLoading(true);
    let reqBody = {
      provider_type: Number(provider_type),
      currency,
      consumer_type: Number(consumer_type),
      bank_code,
      id: Number(id),
    };

    try {
      const response = await putDataWithDotNet(
        ajaxEndpoints.DEFAULT_WALLET_PROVIDER,
        reqBody
      );

      queryCache.invalidateQueries("getDefaultWalletProvider");
      setLoading(false);
      hideModal();
      setSuccessMessage(response.message);
    } catch (error) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "DefaultWalletProvider.jsx",
        },
      });
      queryCache.invalidateQueries("getDefaultWalletProvider");
      hideModal();
      setLoading(false);
      setSignUpError(errorHandler(error));
    }
  };
  let RenderedComponent = null;
  if (!data && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Default Wallet
            Provider
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading") {
    RenderedComponent = (
      <Loader centered="true" text="Loading wallet providers..." />
    );
  } else {
    if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              wallet providers, Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (
      (data && data.data && data.data.length === 0) ||
      (data && !data.data)
    ) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no default
              wallet provider.
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <div className="row m-x-sm m-y-2 grid__padding">
          <div className="table-responsive">
            <table className="table">
              <thead className="bg-lighter-grey">
                <tr>
                  <th>id</th>
                  <th>Provider Type</th>
                  <th>Currency</th>
                  <th>Consumer Type</th>
                  <th>Bank Code</th>
                  {/* <th>Manage</th> */}
                </tr>
              </thead>
              <tbody>
                {data?.data &&
                  data?.data?.map((request, _id) => {
                    const {
                      id,
                      provider_type,
                      currency,
                      consumer_type,
                      bank_code,
                    } = request;
                    return (
                      <tr key={_id}>
                        <td>{id}</td>
                        <td>{provider_type}</td>
                        <td>{currency || "N/A"}</td>
                        <td>{consumer_type}</td>
                        <td>{bank_code}</td>
                        {/* <td>
                          <span
                            className="details btn-manage zoom-element btn-slim"
                            onClick={(e) => {
                              modalHandler(request, "update");
                            }}
                          >
                            EDIT
                          </span>
                        </td> */}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }
  return (
    <div>
      <div className="dataTables_wrapper">
        {signUpError && <Alert message={signUpError} />}
        {successMessage && <Alert message={successMessage} type="success" />}
        <div className="table-view speed-1x animated fadeInRight">
          <div className="d-flex flex-row flex-wrap mb-4">
            <h3 className="page-title">Default Wallet Providers</h3>

            {/* <button
              type=""
              className="btn advancly-white-btn btn-md m-0"
              onClick={(e) => {
                modalHandler("", "create");
              }}
            >
              Create Provider
            </button> */}
          </div>

          {/*Datatable || Loader || Error Message*/}
          {RenderedComponent}
          {data && data?.data && (
            <Paginator
              size={preState.size}
              page={preState.pageNumber}
              count={count}
              changeCurrentPage={(pageNumber) =>
                setPreState({ ...state, pageNumber })
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { loggedInUser } = state.authReducer;

  return {
    loggedInUser,
  };
};
export default withRouter(
  connect(mapStateToProps, { showModal, hideModal })(DefaultWalletProvider)
);
